<script lang="ts">
	import { background_texture_pathname } from 'shared/bzns/holster/image_paths'

	export let image_url: string
	export let belt_loop_image_url: string | null = null
	export let image_alt: string
	export let image_position_algorithm: TrexHolsterLine[`image_position_algorithm`] | null
	export let is_accessory: boolean
	export let flip_x: boolean
	export let is_attached_to_holster: boolean = false
	export let width: number = 180

	const dpr = typeof window !== `undefined` ? window.devicePixelRatio : 2

	$: holster_offset_style = image_position_algorithm === `1` && !is_accessory
		? flip_x
			? `right: 10%;`
			: `left: 10%;`
		: ``

	const q = dpr > 1 ? 20 : 60 // high dpr looks OK with lower quality
	const background_texture_image_src = `${ background_texture_pathname }?$w=${ width }&h=${ width }&fit=crop&q=${ q }&dpr=${ dpr }`

	$: accessory_offset_style = image_position_algorithm === `1` && is_accessory && is_attached_to_holster
		? flip_x ? `left: 22%; top: 10%` : `right: 22%; top: 10%` : ``

	$: offset_style = holster_offset_style || accessory_offset_style

	const imgix_params = `?auto=format,compress&fit=crop&w=${ width }&h=${ width }&dpr=${ dpr }&crop=entropy`

	$: image_url_with_query_params = image_url + imgix_params

	$: img_src = belt_loop_image_url
		? `${ belt_loop_image_url }${ imgix_params }&mark=${ encodeURIComponent(image_url_with_query_params) }&mark-align=center,middle`
		: image_url_with_query_params
</script>

<div class="product_image_container">
	<img
		alt="Background texture"
		class="background_texture"
		src={background_texture_image_src}
		role=presentation
	>

	<div
		class=product_image_wrapper
		data-flip-x={flip_x}
	>
		<img
			class="product_image"
			alt={image_alt}
			src={img_src}
			style={offset_style}
		/>
	</div>
</div>

<style>
	.product_image_container {
		position: relative;
		background-color: var(--better-contrast-background);
		display: flex;
		overflow: hidden;
	}

	.product_image_wrapper {
		aspect-ratio: 1;
		width: 100%;
		filter: drop-shadow(10px 5px 5px #0006) drop-shadow(0 0 25px #000);
	}

	[data-flip-x=true] .product_image {
		transform: scaleX(-1);
	}

	.background_texture {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
	}

	img {
		display: block;
	}

	.product_image {
		width: 100%;
		position: relative;
	}
</style>
